import { Injectable } from '@angular/core';
import { getMatIconFailedToSanitizeLiteralError } from '@angular/material/icon';
import * as myGlobals from '../globalcontants';
import { cSharpMethodType } from '../globalcontants';
import { cSharpURLs } from '../globalcontants';

declare let IsLoadFromApp;
declare let AppVersion;
declare function GetBarcodeCSharp(message: string): any;
declare function SetApiEndPoint(): any;
declare function RequestCSharp(request: string, IsShowLoader: boolean): any;

@Injectable({ providedIn: 'root' })
export class CSharpRequestService {
  public IsLoadFromApp: boolean = this.GetLoadValue();
  public AppVersion: string = this.GetVersionValue();
  // GetBarcode(Modulename) {
  //  if (GetBarcodeCSharp != undefined) {
  //    var paramObj = { Modulename: Modulename };
  //    var reqdata = {
  //      "Method": cSharpMethodType.GET, "Url": cSharpURLs.GetBarcode, "Param": JSON.stringify(paramObj), "EndPoint": myGlobals.baseURL
  //    };
  //    GetBarcodeCSharp(JSON.stringify(reqdata));
  //  }
  // }

  GetLoadValue() {
    try {
      return true;
    } catch {
      return true;
    }
  }

  GetVersionValue() {
    try {
      return '13.2.1';
    } catch {
      return null;
    }
  }

  GetBarcode(ComponentName, functionName) {
    if (GetBarcodeCSharp !== undefined) {
      const paramObj = { componentName: ComponentName, funcName: functionName };
      const reqdata = {
        'Method': cSharpMethodType.GET, 'Url': cSharpURLs.GetBarcode, 'Param': JSON.stringify(paramObj), 'EndPoint': myGlobals.baseURL
      };
      GetBarcodeCSharp(JSON.stringify(reqdata));
    }
  }
  GetVoice(ComponentName, functionName) {
    if (GetBarcodeCSharp !== undefined) {
      const paramObj = { componentName: ComponentName, funcName: functionName };
      const reqdata = {
        'Method': cSharpMethodType.GET, 'Url': cSharpURLs.GetVoice, 'Param': JSON.stringify(paramObj), 'EndPoint': myGlobals.baseURL
      };
      GetBarcodeCSharp(JSON.stringify(reqdata));
    }
  }
  setApiEndPoint() {
    if (SetApiEndPoint !== undefined) {
      SetApiEndPoint();
    }
  }

  RequestGETCSharp(apiURL, inputParam, IsShowLoader= true) {
    if (RequestCSharp !== undefined) {
      const reqdata = {
        'Method': cSharpMethodType.GET, 'Url': apiURL, 'Param': JSON.stringify(inputParam)
      };
      RequestCSharp(JSON.stringify(reqdata), IsShowLoader);
    }
  }

  GetBarcodeByJson(ReqJsondata) {
    GetBarcodeCSharp(ReqJsondata);
  }

  RequestSharpByJson(ReqJsondata, IsShowLoader= true) {
    const json = JSON.parse(ReqJsondata);
    RequestCSharp(JSON.stringify(json), IsShowLoader);
  }

  RequestPOSTCSharp(apiURL, inputModel, IsShowLoader = true) {
    if (RequestCSharp !== undefined) {
      const reqdata = {
        'Method': cSharpMethodType.POST, 'Url': apiURL, 'Param': JSON.stringify(inputModel)
      };
      RequestCSharp(JSON.stringify(reqdata), IsShowLoader);
    }
  }
  SetApiEndPoint(){ localStorage.setItem('apiUrl', '');  }
}
